module.exports = __webpack_public_path__ + "img/3.fa39ea90.png";